export const getCart = async () =>
  (await fetch(`${theme.endpoints.cart}.js`)).json();

export const addItem = async (id: string, quantity = 1) =>
  fetch(`${theme.endpoints.cartAdd}.js`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      id,
      quantity,
    }),
  }).then((res) => res.json());

export const removeItem = async (key: string) => {
  const data = new FormData();
  data.append('id', key);
  data.append('quantity', '0');

  return (
    await fetch(`${theme.endpoints.cartChange}.js`, {
      method: 'post',
      body: data,
    })
  ).json();
};

export default {
  getCart,
  addItem,
  removeItem,
};
